import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { ILaborAndEscalationChangeDialogData } from '../../../../models/common/interfaces/ILaborAndEscalationChangeDialogData';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-labor-and-escalation-change-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslatePipe, MatIconModule],
  templateUrl: './labor-and-escalation-change-dialog.component.html',
  styleUrl: './labor-and-escalation-change-dialog.component.scss'
})
export class LaborAndEscalationChangeDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<LaborAndEscalationChangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: ILaborAndEscalationChangeDialogData
  ) {}

  closeDialog(): void {
    this.dialogRef.close(true);
  }

  cancelDialog(): void {
    this.dialogRef.close(false);
  }
}
